import * as THREE from 'three';
import {acceleratedRaycast, computeBoundsTree, disposeBoundsTree, MeshBVHVisualizer} from 'three-mesh-bvh';
import * as BufferGeometryUtils from 'three/examples/jsm/utils/BufferGeometryUtils.js';
import {GenerateMeshBVHWorker} from 'three-mesh-bvh/src/workers/GenerateMeshBVHWorker.js'

export class CollisionHandler {

	activeGeometry = {};

	changed = false;
	colliders = [];

	working = false;
	colliderQueue = [];

	playerEnt = null;
	playerObj = null;
	playerCollider = null;
	playerIsOnGround = false;
	playerIsInteracting = false;
	playerVelocity = new THREE.Vector3();

	//How much we rotate on key press
	rotationSpeed = Math.PI / 4;

	spawnPositions = {};

	params = {
		displayCollider: false,
		displayBVH: false,
		visualizeDepth: 10,
		gravity: -20,
		playerSpeed: 10,
		physicsSteps: 7,
	};

	//Movement
	walkDirection = new THREE.Vector3()
	rotateAngle = new THREE.Vector3(0, 1, 0)
	rotateQuarternion = new THREE.Quaternion()
	cameraTarget = new THREE.Vector3()

	fadeDuration = 0.2
	_airVelocity = 0.4
	_runVelocity = 0.9
	_walkVelocity = 0.4

	tempAngle

	//Cache
	upVector = new THREE.Vector3(0, 1, 0);
	tempVector = new THREE.Vector3();
	tempVector2 = new THREE.Vector3();
	tempBox = new THREE.Box3();
	tempMat = new THREE.Matrix4();
	tempSegment = new THREE.Line3();


	fwdPressed = false;
	bkdPressed = false;
	lftPressed = false;
	rgtPressed = false;
	shiftPressed = false;

	scene;
	meshWorker;

	constructor(scene, camera, controls) {
		this.scene = scene
		this.camera = camera
		this.controls = controls
		// Add the extension functions
		THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
		THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
		THREE.Mesh.prototype.raycast = acceleratedRaycast;


		this.meshWorker = new GenerateMeshBVHWorker();
		this.bindLocalKeymap()
	}

	bindLocalKeymap() {


		document.addEventListener('keydown', (e) => {
			if (this.playerIsInteracting)
				return

			// console.log("keydown", e.code);
			switch (e.code) {

				case 'ShiftLeft':
					this.shiftPressed = true
					break;
				case 'KeyW':
					this.fwdPressed = true;
					break;
				case 'KeyS':
					this.bkdPressed = true;
					break;
				case 'KeyD':
					this.rgtPressed = true;
					break;
				case 'KeyA':
					this.lftPressed = true;
					break;
				case 'Space':
					this.spacePressed = true;
					break;

			}

		});

		document.addEventListener('keyup', (e) => {

			// console.log("Keyup: " + e.code);
			switch (e.code) {

				case 'ShiftLeft':
					this.shiftPressed = false
					break;
				case 'KeyW':
					this.fwdPressed = false;
					break;
				case 'KeyS':
					this.bkdPressed = false;
					break;
				case 'KeyD':
					this.rgtPressed = false;
					break;
				case 'KeyA':
					this.lftPressed = false;
					break;
				case 'Space':
					this.spacePressed = false;
					break;

			}

		});
	}

	update(delta, angle) {
		this.processColliderQueue()

		if (!this.playerCollider || !this.playerEnt)
			return

		this.processInput(delta);

		// const changed = this.fwdPressed || this.bkdPressed || this.lftPressed || this.rgtPressed;
		// if (!changed && this.playerIsOnGround)
		// 	return;

		//Run collision & physics
		const physicsSteps = this.params.physicsSteps;
		for (let i = 0; i < physicsSteps; i++) {
			this.updateLocalPlayer(delta / physicsSteps, angle);
		}

		this.playerIsOnGround = this.playerVelocity.y === 0;
	}

	getActiveColliders() {
		return this.colliders
	}

	setInteracting(v) {
		this.playerIsInteracting = v
	}

	isInteracting() {
		return this.playerIsInteracting
	}

	processColliderQueue() {
		if (this.working)
			return;

		const c = this.colliderQueue.pop()
		if (!c)
			return

		this.mergeGeometries(c.mergedGeometries, c.terrain, c.terrainData)
	}

	/**
	 * TODO Reset to spawn
	 */
	resetToSpawn() {
		const sp = this.getSpawnPosition()
		console.log("Resetting player position", sp, this.playerEnt, this.spawnPositions)
		this.playerVelocity.set(0, 0, 0);
		this.playerCollider.position.set(sp.x, sp.y, sp.z)
		this.playerObj.position.set(sp.x, sp.y, sp.z)
		this.playerEnt.position = {
			x: sp.x,
			y: sp.y,
			z: sp.z
		}

		// player.position.set( 15.75, - 3, 30 );
		// camera.position.sub( controls.target );
		// controls.target.copy( player.position );
		// camera.position.add( player.position );
		// controls.update();

	}


	reset() {
		this.colliders = [];
		this.playerEnt = null;
		this.playerObj = null;
		this.playerCollider = null;
		this.spawnPositions = {};
		this.tempVector = new THREE.Vector3();
		this.tempVector2 = new THREE.Vector3();
		this.tempBox = new THREE.Box3();
		this.tempMat = new THREE.Matrix4();
		this.shiftPressed = false
		this.fwdPressed = false;
		this.bkdPressed = false;
		this.lftPressed = false;
		this.rgtPressed = false;
	}

	playerHeight() {
		return 1.67 * this.playerObj.scale.y
	}

	addLocalPlayerCollider(playerEnt) {
		console.log("addLocalPlayerCollider::Adding:", playerEnt)
		this.playerEnt = playerEnt;
		this.playerObj = playerEnt.obj;

		const box = new THREE.Box3().setFromObject(this.playerObj);
		// console.log("BOXXXXX", box)
		// this.playerObj.attach(new THREE.BoxHelper(this.playerObj, 0xffff00));

		let height = (box.max.y - box.min.y)
		let width = (box.max.x - box.min.x) / 2
		let depth = (box.max.z - box.min.z) / 2

		width = width < depth ? width : depth
		depth = width
		height = height * 0.75

		// width = width < 1.2 ? 1.2 : width
		// depth = depth < 1.2 ? 1.2 : depth

		this.playerCollider = new THREE.Mesh(
			new THREE.CapsuleGeometry(width, height, 2, 5),
			// new RoundedBoxGeometry(width, height, depth, 10, 0.5),
			new THREE.MeshBasicMaterial()
		);

		this.playerCollider.position.copy(this.playerObj.position);
		this.playerCollider.geometry.translate(0, -height / 2, 0);
		this.playerCollider.capsuleInfo = {
			radius: width,
			segment: new THREE.Line3(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, -height, 0)),
			// segment: new THREE.Line3(new THREE.Vector3(), new THREE.Vector3(0, -height * 0.8, 0.0)),
		};

		// this.playerCollider.castShadow = true;
		// this.playerCollider.receiveShadow = true;
		// this.playerCollider.material.shadowSide = 2;

		// this.playerCollider.material.wireframe = true;
		// this.playerCollider.material.opacity = 0.9;
		// this.playerCollider.material.transparent = true;
		this.playerCollider.visible = false;
		this.scene.add(this.playerCollider)
	}

	getAnimationName() {

		//If we interrupt we should use walk
		let changed = this.fwdPressed || this.bkdPressed || this.lftPressed || this.rgtPressed;
		if (changed && !this.playerEnt.isPlayingAnimations("jump")) {
			if (this.shiftPressed)
				return "run"

			return "walk"
		}

		if (!this.playerEnt.isPlayingAnimations("walk", "idle", "jump", "run")) {
			return this.playerEnt.getCurrentAnimation(); //Just play what we are already doing
		}

		if (this.playerVelocity.y !== 0) {
			return "jump"
		}

		return "idle"
	}

	getRunVelocity() {
		return this._runVelocity * this.params.playerSpeed
	}

	getWalkVelocity() {
		return this._walkVelocity * this.params.playerSpeed
	}

	//Speed the user can move in the air
	getAirVelocity() {
		return this._airVelocity * this.params.playerSpeed
	}

	processInput(delta) {
		const animToPlay = this.getAnimationName();
		this.playerEnt.playAnimation(animToPlay)

		if (this.spacePressed && this.playerIsOnGround) {
			this.playerVelocity.y = 10.0;
			this.playerEnt.playAnimation("jump")
		}

		// move the player
		if (this.fwdPressed || this.bkdPressed || this.lftPressed || this.rgtPressed) {
			let angleYCameraDirection = Math.atan2(
				(this.playerCollider.position.x - this.camera.position.x),
				(this.playerCollider.position.z - this.camera.position.z))

			let directionOffset = this.directionOffset()

			this.tempAngle = new THREE.Matrix4().makeRotationAxis(this.rotateAngle, angleYCameraDirection + directionOffset)
			this.tempAngle.multiply(this.playerCollider.matrix)

			this.rotateQuarternion = new THREE.Quaternion().setFromRotationMatrix(this.tempAngle)
			this.playerObj.quaternion.copy(this.rotateQuarternion, -0.2)

			this.camera.getWorldDirection(this.walkDirection)
			this.walkDirection.y = 0
			this.walkDirection.normalize()
			this.walkDirection.applyAxisAngle(this.rotateAngle, directionOffset)

			const velocity = this.playerIsOnGround ? this.shiftPressed ? this.getRunVelocity() : this.getWalkVelocity() : (this.getAirVelocity())

			// move model & camera
			const moveX = this.walkDirection.x * velocity * delta
			const moveZ = this.walkDirection.z * velocity * delta

			this.playerCollider.position.x += moveX
			this.playerCollider.position.z += moveZ

			this.updateCameraTarget(moveX, moveZ)
		} else {

			this.updateCameraTarget(0, 0)
		}
	}

	setMovementDirection(dir = {left: false, right: false, fwd: false, back: false, shift: false, space: false}) {
		this.shiftPressed = dir.shift
		this.spacePressed = dir.space //TODO wire in so jump can be used in mobile
		this.fwdPressed = dir.fwd
		this.bkdPressed = dir.back
		this.lftPressed = dir.left
		this.rgtPressed = dir.right
	}

	setControls(controls) {
		this.controls = controls
	}

	updateCameraTarget(moveX, moveZ) {
		// move camera
		this.camera.position.x += moveX
		this.camera.position.z += moveZ
		if (this.camera.position.y < 0.1)
			this.camera.position.y = 0.1

		// update camera target
		this.cameraTarget.x = this.playerCollider.position.x
		this.cameraTarget.y = this.playerCollider.position.y
		this.cameraTarget.z = this.playerCollider.position.z
		this.controls.target = this.cameraTarget
	}

	directionOffset() {
		if (this.fwdPressed) {
			if (this.lftPressed) {
				return Math.PI / 4 // w+a
			} else if (this.rgtPressed) {
				return -Math.PI / 4 // w+d
			}
		}

		if (this.bkdPressed) {
			if (this.lftPressed) {
				return Math.PI / 4 + Math.PI / 2 // s+a
			} else if (this.rgtPressed) {
				return -Math.PI / 4 - Math.PI / 2 // s+d
			} else {
				return Math.PI // s
			}
		}
		if (this.lftPressed) {
			return Math.PI / 2 // a
		}

		if (this.rgtPressed) {
			return -Math.PI / 2 // d
		}

		return 0 // w
	}

	updateLocalPlayer(delta, angle) {
		this.playerVelocity.y += this.playerIsOnGround ? 0 : delta * this.params.gravity;
		this.playerCollider.position.addScaledVector(this.playerVelocity, delta);

		for (const idx in this.colliders) {

			//
			this.playerCollider.updateMatrixWorld();

			const newPosition = this.tempVector;
			// adjust player position based on collisions
			const capsuleInfo = this.playerCollider.capsuleInfo;

			this.updateCollider(this.colliders[idx], capsuleInfo)

			// if (!this.changed && this.playerIsOnGround)
			// 	continue

			// get the adjusted position of the capsule collider in world space after checking
			// triangle collisions and moving it. capsuleInfo.segment.start is assumed to be
			// the origin of the player model.
			newPosition.copy(this.tempSegment.start).applyMatrix4(this.colliders[idx].matrixWorld);

			// check how much the collider was moved
			const deltaVector = this.tempVector2;
			deltaVector.subVectors(newPosition, this.playerCollider.position);

			// if the player was primarily adjusted vertically we assume it's on something we should consider ground
			this.playerIsOnGround = deltaVector.y > Math.abs(delta * this.playerVelocity.y * 0.25);

			const offset = Math.max(0.0, deltaVector.length() - 1e-5);
			deltaVector.normalize().multiplyScalar(offset);

			// adjust the player model
			this.playerCollider.position.add(deltaVector);

			if (!this.playerIsOnGround) {
				deltaVector.normalize();
				this.playerVelocity.addScaledVector(deltaVector, -deltaVector.dot(this.playerVelocity));
			} else {
				this.playerVelocity.set(0, 0, 0);
			}

			// const lookTo = this.playerCollider.position.clone();
			// lookTo.y = this.playerObj.position.y
			// this.playerObj.lookAt(lookTo)
			const cpos = new THREE.Vector3().copy(this.playerCollider.position)
			cpos.y -= this.playerHeight()
			this.playerObj.position.copy(cpos)
			// break
		}

		// if the player has fallen too far below the level reset their position to the start
		if (this.playerCollider && this.playerCollider.position.y < -100) {
			this.resetToSpawn();
		}
	}

	/**
	 * Checks for collision between a given collider & capsule
	 * @param collider
	 * @param capsuleInfo
	 */
	updateCollider(collider, capsuleInfo) {
		// adjust player position based on collisions
		this.tempBox.makeEmpty();
		this.tempMat.copy(collider.matrixWorld).invert();
		this.tempSegment.copy(capsuleInfo.segment);

		// get the position of the capsule in the local space of the collider
		this.tempSegment.start.applyMatrix4(this.playerCollider.matrixWorld).applyMatrix4(this.tempMat);
		this.tempSegment.end.applyMatrix4(this.playerCollider.matrixWorld).applyMatrix4(this.tempMat);

		// get the axis aligned bounding box of the capsule
		this.tempBox.expandByPoint(this.tempSegment.start);
		this.tempBox.expandByPoint(this.tempSegment.end);

		this.tempBox.min.addScalar(-capsuleInfo.radius);
		this.tempBox.max.addScalar(capsuleInfo.radius);
		// this.scene.raw().add(new THREE.Box3Helper(this.tempBox, 0xff0000))

		collider.geometry.boundsTree.shapecast({
			intersectsBounds: box => box.intersectsBox(this.tempBox),
			intersectsTriangle: tri => {
				// check if the triangle is intersecting the capsule and adjust the
				// capsule position if it is.
				const triPoint = this.tempVector;
				const capsulePoint = this.tempVector2;

				const distance = tri.closestPointToSegment(this.tempSegment, triPoint, capsulePoint);
				if (distance < capsuleInfo.radius) {

					const depth = capsuleInfo.radius - distance;
					const direction = capsulePoint.sub(triPoint).normalize();
					// console.log("Collision", collider.name, {
					//     "distance": distance,
					//     "depth": depth,
					//     "direction": direction,
					//     "capsulePoint": capsulePoint,
					//     "triPoint": triPoint
					// })

					this.changed = true;
					this.tempSegment.start.addScaledVector(direction, depth);
					this.tempSegment.end.addScaledVector(direction, depth);
				}
			}

		});
	}

	buildMesh(environment, whitelistMap = {}, blacklistMap = {}) {
		const geometries = [];
		const useWhitelist = Object.keys(whitelistMap).length > 0;

		environment.updateMatrixWorld(true);
		environment.traverse(c => {
			if (c.geometry) {

				//We dont support isInterleavedBufferAttribute
				if (c.geometry.attributes && c.geometry.attributes.position.isInterleavedBufferAttribute)
					return;

				if (blacklistMap[c.material.name] || (useWhitelist && !whitelistMap[c.material.name])) {
					return
				}

				const cloned = c.geometry.clone();
				cloned.applyMatrix4(c.matrixWorld);
				for (const key in cloned.attributes) {

					if (key !== 'position') {
						cloned.deleteAttribute(key);
					}

				}

				geometries.push(cloned);

			}
		});

		if (geometries.length === 0) {
			return null
		}

		let geom = null
		try {
			geom = BufferGeometryUtils.mergeBufferGeometries(geometries, true)
		} catch (e) {
			console.debug("mergeBufferGeometries:error", e)
			return
		}

		//Note this is a heavy call
		// console.debug("Merging geometry", geometries)
		return geom;
	}

	_simplifyTerrainMesh(terrain, allowMap = {}, disallowMap = {}) {
		const useWhitelist = Object.keys(allowMap).length > 0;

		terrain.traverse((object) => {
			if (object.type === "Group") {
				for (let i = 0; i < object.children.length; i++)
					object.children[i] = this._simplifyTerrainMesh(object.children[i])
				// for (const child of object.children) {
				// 	this._simplifyTerrainMesh(child)
				// }
			}

			if (object.isMesh) {
				if (disallowMap[object.material.name] || (useWhitelist && !allowMap[object.material.name]))
					object.visible = false;

				// if (object.geometry.attributes.normal.count < 300) {
				// 	object.visible = false;
				// }
				object.geometry.computeVertexNormals();
			}

		})
		return terrain
	}

	buildColliderSimple(terrain, whitelist = [], blacklist = ["KB3D_HTS_GreenHedge.001", "KB3D_HTS_GreenHedge.002", "KB3D_HTS_GreenHedge.003", "KB3D_HTS_GreenHedge.004", "KB3D_HTS_GreenHedge.012", "brown plant", "brown plant.001", "hanging" +
	" plant.001", "light green.001", "Vine6.001", "Vine11", "Vine2", "Vine3", "Vine3.001", "Vine4", "Vine6", "light green"]) {
		const toMerge = {};
		const environment = new THREE.Group();

		const allowed = {}
		const disallowed = {}
		const useWhitelist = whitelist.length > 0
		const useBlacklist = blacklist.length > 0

		//Build map for quick ref
		for (let i = 0; i < whitelist.length; i++)
			allowed[whitelist[i]] = true
		for (let i = 0; i < blacklist.length; i++)
			disallowed[blacklist[i]] = true


		this._simplifyTerrainMesh(terrain, whitelist, blacklist)


		//Loop through and only add valid meshes into our collider geoms
		terrain.traverseVisible(c => {
			if (!c.isMesh)
				return;


			if ((useBlacklist && disallowed[c.material.name]) || (useWhitelist && !allowed[c.material.name]))
				return

			// if (c.geometry.attributes.normal.count < 300) {
			// 	return;
			// }

			c.userData.isTerrain = true;
			c.userData.alphaID = terrain.userData.alphaID || terrain.id;
			c.userData.collider = true;

			c.layers.enable(4);
			c.castShadow = true
			c.receiveShadow = true

			const hex = c.material.color.getHex();
			toMerge[hex] = toMerge[hex] || [];
			toMerge[hex].push(c);
		});


		let idx = 0;
		for (const hex in toMerge) {
			const arr = toMerge[hex];
			arr.forEach(mesh => {
				environment.attach(mesh);
			});
			idx++
		}

		// collect all geometries to merge
		try {
			const mergedGeometries = this.buildMesh(environment, allowed, disallowed)
			if (!mergedGeometries) {
				console.warn("addTerrain::No geometry found, skipping")
				return null;
			}
			return mergedGeometries
		} catch (e) {
			console.error("buildMesh error: ", e)
			return null
		}

		return null
	}

	buildCollider(terrain) {
		const toMerge = {};
		const environment = new THREE.Group();

		terrain.traverse(c => {
			if (c.isMesh) {
				c.userData.isTerrain = true;
				c.userData.alphaID = terrain.userData.alphaID || terrain.id;
				c.layers.enable(4);
				c.castShadow = true
				c.receiveShadow = true

				const hex = c.material.color.getHex();
				toMerge[hex] = toMerge[hex] || [];
				toMerge[hex].push(c);
			}
		});

		let idx = 0;
		for (const hex in toMerge) {
			const arr = toMerge[hex];
			arr.forEach(mesh => {
				environment.attach(mesh);
			});
			idx++
		}

		// collect all geometries to merge
		try {
			const mergedGeometries = this.buildMesh(environment)
			if (!mergedGeometries) {
				console.warn("addTerrain::No geometry found, skipping")
				return null;
			}
			return mergedGeometries
		} catch (e) {
			console.error("buildMesh error: ", e)
			return null
		}

		return null
	}

	addTerrain(terrain, terrainData, mergedGeometries = null) {
		// console.debug("addTerrain::Adding:", terrain)


		terrain.userData.isTerrain = true;
		terrain.userData.alphaID = terrain.userData.alphaID || terrain.id;
		terrain.layers.enable(4);

		if (!mergedGeometries) {
			// console.log("No mesh supplied, generating", terrain, terrainData)

			//If we have collision filters build it out
			if (terrainData.collision_filter) {
				mergedGeometries = this.buildColliderSimple(terrain.clone(), terrainData.collision.whitelist, terrainData.collision.blacklist)
				if (!mergedGeometries)
					return terrain;
			} else {
				mergedGeometries = this.buildCollider(terrain.clone())
				if (!mergedGeometries)
					return terrain;
			}
		}

		this.colliderQueue.push({
			mergedGeometries: mergedGeometries,
			terrain: terrain,
			terrainData: terrainData
		})

		return terrain;
	}

	async mergeGeometriesAsync(mergedGeometry) {
		if (!mergedGeometry)
			return null

		const w = new GenerateMeshBVHWorker()

		try {
			const bvh = await w.generate(mergedGeometry)
			if (bvh) {
				mergedGeometry.boundsTree = bvh
			}
		} catch (e) {
			console.debug("Unable to merge geometry", e)
			w.dispose()
			return null
		}

		w.dispose()
		return new THREE.Mesh(mergedGeometry)
	}

	mergeGeometries(mergedGeometry, terrain, terrainData, debug = false) {
		if (!mergedGeometry)
			return null

		try {
			this.working = true
			this.meshWorker.generate(mergedGeometry).then(bvh => {
				mergedGeometry.boundsTree = bvh

				const collider = new THREE.Mesh(mergedGeometry);
				collider.name = `collider-mesh-terrain-${terrain.uuid}`;
				collider.layers.enable(4);
				this.colliders.push(collider);


				//In debug mode we add visualisers to the scene
				if (debug) {
					collider.material.wireframe = true;
					collider.material.opacity = 0.5;
					collider.material.transparent = true;

					const visualizer = new MeshBVHVisualizer(collider, this.params.visualizeDepth);
					const grp = new THREE.Group();
					grp.name = `terrain-grp-${terrain.uuid}`;
					grp.add(visualizer);
					// grp.add(collider);
					visualizer.visible = true;
					// collider.visible = false;

					this.activeGeometry[terrain.uuid] = grp
					this.scene.add(grp)
					return grp
				}

			}).catch(e => {
				console.error("Unable to merge geometry c2", {
					terrain: terrain,
					data: terrainData,
					geometries: mergedGeometry,
					error: e
				})
				this.working = false
				this.meshWorker = new GenerateMeshBVHWorker();
			}).finally(() => {
				this.working = false
			});
		} catch (e) {
			console.error("Unable to merge geometry", {
				terrain: terrain,
				data: terrainData,
				geometries: mergedGeometry,
				error: e
			})
			this.working = false
			this.meshWorker = new GenerateMeshBVHWorker();
		}
	}

	removeTerrain(uuid, scene) {
		// scene.remove(`terrain-grp-${uuid}`)
		//

		const colliderIdx = this.colliders.findIndex(collider => collider.name === `collider-mesh-terrain-${uuid}`)
		if (colliderIdx > -1)
			this.colliders.splice(colliderIdx, 1)

		const geom = this.activeGeometry[uuid]
		if (!geom)
			return

		console.debug("removeTerrain::Removing:", uuid, geom)
		scene.remove(geom)
		delete this.activeGeometry[uuid]

	}

	getSpawnPosition() {
		if (this.playerEnt == null)
			return new THREE.Vector3(0, 2, 0)

		if (this.spawnPositions[this.playerEnt.device_type])
			return this.spawnPositions[this.playerEnt.device_type]

		return new THREE.Vector3(0, 2, 0)
	}

	setSpawnPositions(positionMap) {
		console.log("Setting spawn positions", positionMap)
		this.spawnPositions = positionMap;
	}

	setSpeed(speed) {
		this.params.playerSpeed = speed;
	}
}
